import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';
import {User} from '../models/user.model';

@Injectable({providedIn: 'root'})
export class UserService {

    private users: User[] = [];
    usersChanged = new Subject<User[]>();

    constructor(private http: HttpClient) {
    }

    setUser(users: User[]) {
        this.users = users;
        this.usersChanged.next(this.users.slice());
    }

    getUser() {
        return this.users;
    }

    getSubUsers() {
        return this.users.filter(user => +user.level === 3);
    }

    getUserNameById(id: number) {
        return this.users.filter(user => user.id === id)[0].user_name;
    }

    setIPAddress() {
        return this.http.get('https://api.ipify.org/?format=json');
    }

}
